export default "__VITE_ASSET__b96e9908__"